// src/context/SeasonContext.jsx
import { createContext, useContext } from "react";

const SeasonContext = createContext();

export function SeasonProvider({ children }) {
  const now = new Date();
  const month = now.getMonth() + 1;

  let seasonLabel = "";

  if (month >= 3 && month <= 5) {
    seasonLabel = "Spring 2026";
  } else if (month >= 6 && month <= 8) {
    seasonLabel = "Summer 2026";
  } else if (month >= 9 && month <= 11) {
    seasonLabel = "Autumn 2026";
  } else {
    seasonLabel = "Winter 2026";
  }

  return (
    <SeasonContext.Provider value={{ seasonLabel }}>
      {children}
    </SeasonContext.Provider>
  );
}

export function useSeason() {
  return useContext(SeasonContext);
}
